import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import { radioInputDataReducer } from 'Components/Forms/FormReducers/RadioInputReducer';
import { selectInputDataReducer } from 'Components/Forms/FormReducers/SelectInputReducer';
import { checkboxInputDataReducer } from 'Components/Forms/FormReducers/CheckboxInputReducer';
import { useReducer, useRef } from "react";

var getVarValue = function (value) {
    if (typeof value === 'function') {
        return value();
    }
    else {
        return value;
    }
};



export function GetRadioInputObj ({ id, name, value, radioButtons, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, inline }) {
    var radioInputObj = {
        type: 'radio',
        id: id,
        name: name,
        value: value,
        radioButtons: radioButtons,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            inline: inline
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isChecked==true){
                    return ans[x].value;
                }
            }
            return '';
        }
    };

    return useReducer(radioInputDataReducer, radioInputObj);
}

export function GetCheckboxInputObj ({ id, name, value, checkBoxes, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, inline }) {
    var checkInputObj = {
        type: 'checkbox',
        id: id,
        name: name,
        value: value,
        checkBoxes: checkBoxes,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            inline: inline
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            var checked = [];
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isChecked==true){
                    checked.push(ans[x].value);
                }
            }
            if(checked.length==0){
                return null;
            }
            else {
                return checked;
            }
            
        }
    };

    return useReducer(checkboxInputDataReducer, checkInputObj);
}


export function GetSelectInputObj ({ id, name, value, options, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var selectInputObj = {
        type: 'select',
        id: id,
        name: name,
        value: value,
        options: options,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isSelected==true){
                    return ans[x].value;
                }
            }
            return null;
        }
    };

    return useReducer(selectInputDataReducer, selectInputObj);
}

export function GetPlainTextInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var plainTextInputObj = {
        type: 'plain',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, plainTextInputObj);
}

export function GetTableauUserPlainTextInputData (fieldName, fieldValue) {
    switch (fieldName) {
        case 'tableauUserPso':
            return GetPlainTextInputObj({
                id: 'tableauUser_' + fieldName,
                name: 'tableauUser_' + fieldName,
                value: fieldValue,
                label: 'Select PSO',
                description: '',
                title: '',
                placeholder: 'Select PSO',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
    }
}

export function GetTableauUserSelectInputData (fieldName, fieldValue) {
    switch (fieldName) {
        
        case 'tableauUserPso':
            return GetSelectInputObj({
                id: 'tableauUser_' + fieldName,
                name: 'tableauUser_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Select PSO',
                description: '',
                title: '',
                placeholder: 'Select a PSO who has production submissions',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
    }
}

export function GetTableauUserRadioInputData (fieldName, fieldValue, inline) {
    switch (fieldName) {
        case "tableauUserStatus":
            return GetRadioInputObj({
                id: "tableauUser_" + fieldName,
                name: "tableauUser_" + fieldName,
                value: '',
                radioButtons: [
                    {
                        id: "active",
                        label: "Active",
                        name: "selectedStatus",
                        value: 1,
                        title: "",
                        isChecked: fieldValue==1 ? true : false
                     },
                    {
                        id: "inactive",
                        label: "Inactive",
                        name: "selectedStatus",
                        value: 0,
                        title: "",
                        isChecked: fieldValue==0 ? true : false
                    }
                ],
                label: 'User Status',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                inline: inline != null ? inline : true,
                getValue: (ans) => {
                    //console.log(ans);
                    var checked = null;
                    for(var x = 0 ; x<ans.length ; x++){
                        if(ans[x].isChecked==true){
                            checked=ans[x].value;
                        }
                    }
                    
                    return checked; 
                }
                
            });
    }
}

export function GetTableauUserCheckboxInputData (fieldName, fieldValue) {
        
    switch (fieldName) {
       
        case 'tableauUserAccess':
            return GetCheckboxInputObj({
                id: 'tableauUser_' + fieldName,
                name: 'tableauUser_' + fieldName,
                value: fieldValue,
                checkBoxes: [],
                label: 'Grant Access',
                description: '',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                inline: false
            });
    }
}
